export const timeSince = (date?: Date, timeInMili?: number): string => {
  if (!date && !timeInMili) {
    return '';
  }
  const seconds = date
    ? Math.floor((new Date().getTime() - date.getTime()) / 1000)
    : timeInMili;

  if (seconds === undefined) {
    return '';
  }

  let interval = seconds / 31536000;

  if (interval > 1) {
    return `${Math.floor(interval)} years`;
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return `${Math.floor(interval)} months`;
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return `${Math.floor(interval)} days`;
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return `${Math.floor(interval)} hours`;
  }
  interval = seconds / 60;
  if (interval > 1) {
    return `${Math.floor(interval)} min`;
  }
  return `${Math.floor(seconds)} sec`;
};
